// ═══════════════════════════════════════════════════════════════════
//  modules/erp/BouxXpBar.js
//  BouxXpBar
// ═══════════════════════════════════════════════════════════════════

import { THEME } from "../../socle/theme";
import { BOUX_LEVEL_XP, BOUX_MAX_XP } from "./boux";

export function BouxXpBar({ niveau, xp, color }) {
  const maxXp = BOUX_MAX_XP;
  const levelXp = BOUX_LEVEL_XP[niveau] || 0;
  const nextXp = BOUX_LEVEL_XP[niveau + 1] || maxXp;
  const pct = niveau >= 10 ? 100 : Math.round(((xp - levelXp) / (nextXp - levelXp)) * 100);
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 3 }}>
      <div style={{ display: "flex", justifyContent: "space-between", fontSize: 10, color: THEME.textMuted }}>
        <span>Niv. {niveau}</span>
        <span>{xp} / {maxXp} XP</span>
      </div>
      <div style={{ background: THEME.border, borderRadius: 4, height: 6, overflow: "hidden" }}>
        <div style={{ background: color, width: `${Math.min(100, pct)}%`, height: "100%", transition: "width 0.3s ease" }} />
      </div>
    </div>
  );
}
